import React from 'react'
import './PathToAI.css'

interface StepProps {
  number: string
  label: string
  description: string[]
  isActive: boolean
}

const Step: React.FC<StepProps> = ({number, label, description, isActive}) => (
  <div className={`step ${isActive ? 'active-step' : 'inactive-step'}`}>
    <div className="step-number">{number}</div>
    <div className="step-label">{label}</div>
    <div className="step-description">
      {description.map((desc, index) => (
        <React.Fragment key={index}>
          <div className="description-item">{desc}</div>
          {index < description.length - 1 && <hr className="description-divider" />}
        </React.Fragment>
      ))}
    </div>
  </div>
)

const PathToAI: React.FC = () => {
  const steps = [
    {
      number: '01',
      label: 'Assessment',
      description: [
        'Comprehensive AI System Risk Assessment',
        'Model Audit and Validation',
        'Explainability and Transparency Review',
      ],
      isActive: true,
    },
    {
      number: '02',
      label: 'Consultation',
      isActive: false,
      description: [],
    },
    {
      number: '03',
      label: 'Development',
      isActive: false,
      description: [],
    },
    {
      number: '04',
      label: 'Training',
      isActive: false,
      description: [],
    },
  ]

  return (
    <div className="path-outer-container">
      <img src={'/imgs/whitepanel.png'} alt="Path to AI background" className="background-image" />
      <div className="path-content-container">
        <div className="path-content">
          <h2 className="path-title">Path to AI Effectiveness</h2>
          <div className="steps-container">
            {steps.map((step, index) => (
              <React.Fragment key={step.number}>
                <Step {...step} />
                {index < steps.length - 1 && <div className="step-line" />}
              </React.Fragment>
            ))}
          </div>
        </div>
        <div className="bottom-text-container">
          <img src={'/imgs/star.png'} alt="Star" className="star-icon" />
          <span className="bottom-text">
            Full service AI system developers are available for around the clock care.
          </span>
          <img src={'/imgs/star.png'} alt="Star" className="star-icon" />
        </div>
      </div>
    </div>
  )
}

export default PathToAI
